import { render, staticRenderFns } from "./PersonalSearch.vue?vue&type=template&id=1cf513e3&"
import script from "./PersonalSearch.vue?vue&type=script&lang=js&"
export * from "./PersonalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports